export {
  ArrowDivider,
  type ArrowDividerProps,
  ArrowSize,
} from './ArrowDivider';
